import { reduce } from 'lodash';

const ProductBundleCalculator = {
  originalPrice(productBundle) {
    return reduce(
      productBundle.bundled_products,
      (sum, bundledProduct) => sum + parseFloat(bundledProduct.listing.original_price.amount),
      0,
    );
  },

  discountedPrice(productBundle) {
    return reduce(
      productBundle.bundled_products,
      (sum, bundledProduct) => sum + parseFloat(bundledProduct.listing.buyer_price.amount),
      0,
    );
  },

  bundledProductsCount(productBundle) {
    return productBundle.bundled_products.length;
  },

  totalPrice(productBundle) {
    // The 'before bundle' price does not account for any sales that may be applied
    // on the main or product
    const amount = parseFloat(productBundle.main_listing.price.amount) + this.discountedPrice(productBundle);
    return { amount, symbol: productBundle.main_listing.price.symbol };
  },

  totalBuyerPrice(productBundle) {
    // Bundles don't apply sale prices, so use the main listing's list price
    // instead of buyer_price(which incorporates sales)
    const amount = parseFloat(productBundle.main_listing.price.amount) + this.discountedPrice(productBundle);
    return { amount, symbol: productBundle.main_listing.buyer_price.symbol };
  },
};

export default ProductBundleCalculator;



// WEBPACK FOOTER //
// ./javascripts/components/product_bundles/product_bundle_calculator.js